const PERSONAL_FIELDS = ['firstName', 'lastName', 'email', 'mobile'];

export default function syncPersonalFields(records, person, idField = 'personId') {
  if (!person.id) return records;
  const fields = PERSONAL_FIELDS.reduce((result, field) => (
    Object.prototype.hasOwnProperty.call(person, field) ? { ...result, [field]: person[field] } : result
  ), {});
  return records.map(record => (
    record[idField] === person.id ? { ...record, ...fields } : record
  ));
}
